import { Injectable } from '@angular/core';
import { Analytics, isSupported, logEvent } from '@angular/fire/analytics';
import { FirebaseApp } from '@angular/fire/app';

export interface EventParams {
  event_category: string
  event_label: string
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private analyticsInstance: Analytics | null = null;

  constructor(private firebaseApp: FirebaseApp) {}

  async initializeAnalytics(): Promise<void> {
    if (!this.analyticsInstance) {
      const supported = await isSupported();
      if (supported) {
        const { getAnalytics } = await import('firebase/analytics'); 
        this.analyticsInstance = getAnalytics(this.firebaseApp);
        console.debug('Analytics initialized.');
      }
    }
  }

  deactivateAnalytics(): void {
    if (this.analyticsInstance) {
      console.debug('Deactivating Analytics...');
      this.analyticsInstance = null;
    }
  }

  activateAnalytics(): void {
    if (!this.analyticsInstance) {
      console.debug('Activating Analytics...');
      this.initializeAnalytics();
    }
  }




  trackEvent(eventName: string, eventParams: EventParams): void {
    if (this.analyticsInstance) {
      logEvent(this.analyticsInstance, eventName, eventParams);
    } else {
      console.debug('Analytics not initialized yet.');
    }
  }
}